import { Component, Signal, inject } from '@angular/core';
import { NgIf, NgTemplateOutlet } from '@angular/common';
import { MediaQueryService } from 'src/app/services/media-query/media-query.service';
import { HeaderComponent } from 'src/app/shared/toolbox/header/header.component';
import {map, filter} from 'rxjs/operators';
import {toSignal} from '@angular/core/rxjs-interop';
import { SidebarComponent } from 'src/app/shared/toolbox/sidebar/sidebar.component';

@Component({
  standalone: true,
  selector: 'app-lb-survey',
  templateUrl: './lb-survey.component.html',
  styleUrls: ['./lb-survey.component.scss'],
  imports: [HeaderComponent, NgIf, SidebarComponent, NgTemplateOutlet]
})
export class LbSurveyComponent {

  private mediaQueryService: MediaQueryService = inject(MediaQueryService);
  public isMobile: Signal<boolean> = toSignal(
    this.mediaQueryService
      .getDisplayType()
      .pipe(map(({isMobile}) => isMobile)),
    {initialValue: window.innerWidth < 768}
  );

  ngOnInit() {
    console.log(this.isMobile())
  }
}
